import { HttpClient } from "@angular/common/http";
import { Injectable,Injector } from "@angular/core";
import { BaseService } from "./base.service";

@Injectable()
export class TestService extends BaseService {
    constructor(
        public httpClient: HttpClient,
        protected injectorObj:Injector
    ) {
        super(injectorObj);
    }


    async uploadFile(file: File,request_data={}) {
        let formData = new FormData();
        const data = JSON.stringify(request_data)
        formData.append('data', data)
        if(file){
            formData.append('file', file);
        }
        this.logger.debug("uploadFile");
        return await this.post('/api/services/test/imgGen', formData)
    }


}
